import { haveFilterQuery, paginator, haveSort } from '../../common/auxFun'

const endpointTanks = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/alvic/tanks${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  BY_ID: (id) => `/v1/alvic/tanks/ownStation/${id}`,
  UPDATE_MIN_STROCK: ({ ownStationId, tankNum }) =>
    `/v1/alvic/tanks/ownStation/${ownStationId}/tankNum/${tankNum}`,
}

export default endpointTanks
